import { isUndefined } from '@aloft/toolkit-shared';
import { Block, Flex } from '@aloft/toolkit-sui';

import { useState } from 'react';

// eslint-disable-next-line aloft/prefer-sound-ui-radio
import { StyleRadio } from '../../../components/map/StyleRadio.tsx';
import { INITIAL_STYLE } from '../../../components/map/constants.ts';
import { NoData } from '../NoData.tsx';
import { MlsMapPropertyTooltip } from './MlsMapPropertyTooltip.tsx';
import { useMLSMap } from './useMLSMap.ts';
import { useSubjectPinCoordinates } from './useSubjectPinCoordinates.ts';

import './mlsMap.scss';

export const MLSMap = ({ isPopout }: { isPopout: boolean }) => {
  const [mapStyle, setMapStyle] = useState(INITIAL_STYLE.url);

  const subjectPinCoordinates = useSubjectPinCoordinates();

  const { mapRef, mapContainerRef, activeProperty } = useMLSMap();

  if (!subjectPinCoordinates.isLoading && isUndefined(subjectPinCoordinates.coordinates)) {
    return <NoData text="No property location available" />;
  }

  return (
    <Flex
      ref={mapContainerRef}
      height={isPopout ? 'calc(100% - 2.5rem)' : '100%'}
      width="100%"
      position="absolute"
      overflow="hidden"
      top={isPopout ? '2.5rem' : '0'}
    >
      <Block
        position="absolute"
        bottom="10px"
        right="10px"
        zIndex="1"
        backgroundColor="textOffset"
        padding="8px 16px"
        borderRadius="4px"
      >
        <StyleRadio mapRef={mapRef} style={mapStyle} onStyleChange={setMapStyle} />
      </Block>
      <MlsMapPropertyTooltip property={activeProperty} mapRef={mapRef} />
    </Flex>
  );
};
